import React from 'react'
import AdminPageWithSmartview from 'pages/app/AdminPageWithSmartview'
import { WhenRouteHasParameter } from '@morningtrain/react-navigation'
import PermissionsOverview from 'pages/app/settings/permissions/partials/PermissionsOverview'
import PermissionsForRole from 'pages/app/settings/permissions/partials/PermissionsForRole'

export default function Permissions (props) {
  return (
    <AdminPageWithSmartview withGlobalDepartmentFilter={false} defaultSmartviewSize='lg'>
      <WhenRouteHasParameter name='role'>
        <PermissionsForRole />
      </WhenRouteHasParameter>
      <WhenRouteHasParameter name='role' negate>
        <PermissionsOverview />
      </WhenRouteHasParameter>
    </AdminPageWithSmartview>
  )
}
